const search = {
  search: {
    title: 'Alojamientos disponibles en Urubici',
    sortRecommended: 'Recomendados',
    sortPriceLow: 'Menor precio',
    sortPriceHigh: 'Mayor precio',
    sortRating: 'Mejor valoración',
    available: 'disponibles',
    nightSingular: 'noche',
    nightPlural: 'noches',
    guestSingular: 'huésped',
    guestPlural: 'huéspedes',
    propertySingular: 'propiedad',
    propertyPlural: 'propiedades',
    unitSingular: 'unidad',
    unitPlural: 'unidades',
    reviewSingular: 'valoración',
    reviewPlural: 'valoraciones',
    changeDates: 'Cambiar fechas',
    viewAvailability: 'Ver disponibilidad',
    from: 'desde',
    perNightTotal: '/ noche · total',
    availableUnitSingular: 'disponible',
    availableUnitPlural: 'disponibles',
    realTimePrices: 'Precios y disponibilidad en tiempo real vía Reserve Connect.',
    loadingSearch: 'Buscando alojamientos disponibles...',
    errorTitle: 'No se pudo buscar',
    errorMessage: 'El servicio de disponibilidad no está disponible en este momento. Intente nuevamente en unos instantes.',
    noResultsTitle: 'No hay alojamientos disponibles',
    noResultsDesc: 'No encontramos propiedades disponibles para las fechas seleccionadas.',
    noResultsHint: 'Intente cambiar las fechas o hable con nuestra Central de Reservas.',
    pageTitle: 'Alojamientos disponibles en Urubici - Reserve Connect',
    pageDescription: 'Encuentre alojamientos disponibles en Urubici, SC de {{checkIn}} a {{checkOut}}. Precios reales y disponibilidad confirmada.',
    breadcrumbSearch: 'Buscar',
  },
};
export default search;
